import { JSX, ReactNode } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
} from "@mui/material";
import { Box } from "@mui/system";
import { Button, Typography } from "@platform/design-system";

export type ConfirmDialogProps = {
  isOpen: boolean;
  title: string;
  message: ReactNode;
  subMessage?: ReactNode;
  confirmBtnMsg?: string;
  onConfirm?: VoidFunction;
  onClose?: VoidFunction;
  closeBtnMsg?: string;
  contentColor?: string;
};

export default function ConfirmDialog({
  isOpen,
  title,
  message,
  subMessage,
  confirmBtnMsg,
  onConfirm,
  onClose,
  closeBtnMsg = "Close",
  contentColor = "text.secondary",
}: ConfirmDialogProps): JSX.Element {
  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      aria-labelledby="confirm-dialog-title"
      aria-describedby="confirm-dialog-description"
      maxWidth="sm"
    >
      <DialogContent>
        <Typography variant="header-small" id="confirm-title">
          {title}
        </Typography>
        <Box mt={2} mb={2}>
          <DialogContentText
            id="confirm-description"
            sx={{ color: contentColor }}
          >
            {message}
          </DialogContentText>
        </Box>
        {subMessage && (
          <Box mt={2} mb={2}>
            <DialogContentText
              id="confirm-sub-description"
              sx={{ color: contentColor }}
            >
              {subMessage}
            </DialogContentText>
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="tertiary">
          {closeBtnMsg}
        </Button>
        {confirmBtnMsg && (
          <Button onClick={onConfirm} variant="primary">
            {confirmBtnMsg}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
}
